import { createAsyncThunk } from '@reduxjs/toolkit';
import { Advertise } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchAdvertise,
  FindAdvertise,
  GetAdvertise,
} from './interface';

export const findAdvertise = createAsyncThunk(
  'advertise/findAdvertise',
  async (values: FindAdvertise, { rejectWithValue }) => {
    try {
      const response = await Advertise.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createAdvertise = createAsyncThunk(
  'advertise/createAdvertise',
  async (values: CreatePatchAdvertise, { rejectWithValue }) => {
    try {
      const response = await Advertise.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchAdvertise = createAsyncThunk(
  'advertise/patchAdvertise',
  async (
    { id, ...values }: CreatePatchAdvertise,
    { rejectWithValue }
  ) => {
    try {
      const response = await Advertise.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getAdvertise = createAsyncThunk(
  'advertise/getAdvertise',
  async ({ id }: GetAdvertise, { rejectWithValue }) => {
    try {
      const response = await Advertise.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
